import React, { useEffect, useState } from 'react';
import { fetchUsers } from '../../api/users';
import { useNavigate } from "react-router-dom";

const UserList = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();
  
  const nextClick = async () => {
    //navigate("/UserListNext", { state: { data1: 1234, data2: 4567 } });
    navigate("/users/userListNext", { state: users });
  };

  useEffect(() => {
    const loadUsers = async () => {
      try {
        const data = await fetchUsers();
        setUsers(data.data);
      } catch (error) {
        console.error('사용자 목록을 불러오는 중 오류 발생:', error);
      } finally {
        setLoading(false);
      }
    };

    loadUsers();
  }, []);

  if (loading) return <p>로딩 중...</p>;

  return (
    <div>
      <h2>사용자 목록</h2>
      <ul>
        {users.map(user => (
          <li key={user.id}>{user.userNm} ({user.age})</li>
        ))}
      </ul>
      <div>
        <button onClick={nextClick}>다음화면으로</button>
      </div>
    </div>
    
  );
};

export default UserList;
